var loader = require('loader');

(function($) {

    $.fn.notification = function(options) {

        //Modal components
        var $notification = $('<div class="notification"></div>'),
            $notificationTitle = $('<p class="notification-title"></p>');


        //Default options.
        var settings = $.extend({
            title: 'Success',
            error: false,
            important: false
        }, options);


        //Build the basic notification and prepend to <body>
        var $builtNotification = $notification;
        $('body').append($builtNotification);
        //After adding elements to the DOM, use getComputedStyle to force the browser to recalc and recognize the elements that we just added. This is so that CSS animation has a start point
        var notificationElement = document.getElementsByClassName('notification')[0];
        window.getComputedStyle(notificationElement).height;


        //Check if settings exists and build elements if so
        if (settings.error === true) {
            $notification.addClass('error');
        }

        if (settings.title) {
            $notification.append($notificationTitle);
            $notificationTitle.html(settings.title);
        }

        if (settings.important === true) {
            $notification.addClass('important');
            $notification.append('<a href="#" class="notification-close"><svg class="icon icon-M fill-white"><use xlink:href="#icon-close"></use></svg></a>');

            $('.notification-close').on('click', function(e) {
                e.preventDefault();
                closeNotification();
            });
        }


        //Now it is built, show the notification (plus hide any loaders)
        $('window').hideLoader();
        $('window').hideBtnLoader();
        $notification.addClass('notification-open');


        //After a set time, hide the notification (time needs to be mirrored in notification sass file)
        function notificationTimer() {
            closeNotification();
        }

        if (settings.important === false) {
            setTimeout(notificationTimer, 3200);
        }


        //Close notification
        var closeNotification = function() {
            //Remove the open class name
            $notification.removeClass('notification-open');

            //Listen for CSS transitionend event and then remove the nodes from the DOM
            $notification.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
                $notification.remove();
            });
        };


        return this;

    };

}(jQuery));



// WEBPACK FOOTER //
// ./library/js/plugins/notification.js